export const addUtmtoURL = (url: string): string => `${url}${url.indexOf('?') === -1 ? '?' : '&'}utm_source=opineo`;

export enum UtmParams {
    utmSource = 'utm_source',
    utmMedium = 'utm_medium',
    utmCampaign = 'utm_campaign'
}
